module.exports = __webpack_public_path__ + "static/img/higashi_01.4b81ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/higashi_01.png
// module id = emnm
// module chunks = 0